// hooks/useRankings.js
import { useMemo } from "react";

export const useRankings = (students) => {
  const academicRankings = useMemo(() => {
    return students
      .filter((s) => Number(s.GPA) || Number(s.GradePercent))
      .sort((a, b) => {
        const gpaDiff = (Number(b.GPA) || 0) - (Number(a.GPA) || 0);
        return gpaDiff !== 0
          ? gpaDiff
          : (Number(b.GradePercent) || 0) - (Number(a.GradePercent) || 0);
      })
      .slice(0, 10)
      .reduce((acc, s, i) => {
        acc[s.id] = i + 1;
        return acc;
      }, {});
  }, [students]);

  const needRankings = useMemo(() => {
    return students
      .filter((s) => Number(s.bursary_total_income))
      .sort(
        (a, b) =>
          Number(a.bursary_total_income) - Number(b.bursary_total_income)
      )
      .slice(0, 10)
      .reduce((acc, s, i) => {
        acc[s.id] = i + 1;
        return acc;
      }, {});
  }, [students]);

  return { academicRankings, needRankings };
};
